// SPDX-FileCopyrightText: 2026 Igor Brkic <igor@hyperglitch.com>
//
// SPDX-License-Identifier: GPL-3.0-or-later

/**
 * Who this tool is, in one place.
 *
 * sigmaKi (ΣKi) is the second tool in the suite after deltaKi (ΔKi); the shape
 * of this object mirrors deltaKi's so the two stay recognisably one product.
 */

/** The mark on its own: header, favicon, dialog. */
export const LOGO_MARK = 'logo.svg';
/** Mark plus wordmark: the splash, and the empty canvas. */
export const LOGO_FULL = 'logo-full.svg';

export const BRAND = {
  name: 'sigmaKi',
  /** The wordmark as it appears in the interface. */
  short: 'ΣKi',
  tagline: 'KIKIT BASED PCB PANELIZATION',
  /** Sentence-case for the tab, where all-caps reads as shouting. */
  titleTagline: 'KiKit based PCB panelization',
  author: 'Igor Brkić',
  authorEmail: 'igor@hyperglitch.com',
  company: 'HYPERGLITCH Ltd',
  companyUrl: 'https://hyperglitch.com',
  docsUrl: 'https://hyperglitch.com/articles/kitools',
  repoUrl: 'https://gitlab.com/hyperglitch/sigmaki-web',
} as const;

/** How long the splash stays up before fading, in milliseconds. */
export const SPLASH_MS = 1000;
